import React, { useState } from 'react';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';
import { Facet } from './facet';
import VersionPickerFacet from './versionPickerFacet';
import { Link } from 'gatsby';
import documentationLogo from '../../images/domino-logo-large.png';
import { FaBars } from 'react-icons/fa';
import ToggleNightMode from '../navbar/ToggleNightMode';
const FacetsMenu = () => {
  const [showFilters, setShowFilters] = useState<boolean>(true);
  const [collapsed, setCollapsed] = useState<boolean>(false);

  return (
    <>
      {/* Hamburger Menu (Visible on Mobile) */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="flex md:hidden fixed mt-0.5 top-3 right-4 w-8 h-8 text-very-dark-grey items-center justify-center dark:text-bright-white text-2xl bg-bright-white dark:bg-very-dark-grey border border-medium-dark-grey cursor-pointer z-40 rounded"
      >
        <FaBars className="w-6 h-4" />
      </button>
      <div
        className={`
      fixed md:sticky 
      top-0 left-0 bottom-0 
      bg-very-dark-grey 
      h-screen
      transition-all duration-300 
      z-40
      ${collapsed ? '-translate-x-full md:translate-x-0' : 'translate-x-0'}
      ${collapsed ? 'w-0 md:w-80' : 'w-full md:w-80'}
      ${collapsed ? 'overflow-hidden md:overflow-visible' : 'overflow-visible'}
    `}
      >
        <div id="leftnav" className="h-full flex flex-col overflow-y-auto sidebar-leftnav">
          <div className="flex flex-row items-center h-10 ml-8 pr-4 mt-3 mb-4 ">
            <div className="flex-grow justify-start">
              <Link className="w-28" to="/" onClick={() => setCollapsed(true)}>
                <img
                  loading="lazy"
                  src={documentationLogo}
                  className="cursor-pointer w-28 h-5 m-0"
                  alt="domino logo"
                  id="domino-logo"
                />
              </Link>
            </div>
            <div className="w-12 flex flex-grow md:hidden justify-end">
              <ToggleNightMode
                visible={collapsed ? false : true}
                darkBackground="bg-medium-dark-grey"
                lightBackground="bg-medium-dark-grey"
                sunStroke="stroke-bright-white"
                moonStroke="stroke-bright-white"
                lightDotColour="after:bg-bright-white"
                darkDotColour=""
              />
            </div>
            <div className="w-8 flex justify-end">
              <button
                onClick={() => setCollapsed(true)}
                className="md:hidden w-8 h-8 text-white text-2xl bg-transparent border border-medium-dark-grey cursor-pointer z-50 rounded"
              >
                &times;
              </button>
              </div>
          </div>
          <hr className="border-medium-dark-grey w-full" />
          <div className="pt-8">
            <div
              onClick={() => setShowFilters(!showFilters)}
              className="cursor-pointer text-white md:hidden w-full px-2 text-sm md:text-base font-semibold md:font-bold flex flex-row justify-between items-center"
            >
              <span>Search Filters</span>
              {!showFilters && <MdArrowDropDown size={25} />}
              {showFilters && <MdArrowDropUp size={25} />}
            </div>
            <div className={`sidebar-search${showFilters ? '' : ' invisible h-0 md:h-auto md:visible'}`}>
              <div className="mx-8 mt-2 mb-1 lg:text-base font-bold text-bright-white">Search by:</div>
              <VersionPickerFacet title="Versions" facetName="docsversion" />
              {/*<Facet facetName="docsversion" title="Versions" />*/}
              <Facet facetName="docsguide" title="Guide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FacetsMenu;
